






import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: 'reportContainer'
})
export default class ReportContainer extends Vue {
  @Prop({required: false})
  cssClass: string;
}
